var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftMobile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 24,
    viewBox: "0 0 13 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.728 11.341L1.585.26C1.216-.095.628-.085.272.282c-.348.358-.348.925 0 1.283l10.487 10.43L.272 22.423c-.363.36-.363.945 0 1.306.363.36.95.36 1.313 0l11.143-11.083c.363-.36.363-.945 0-1.306z",
    transform: "translate(-13.000000, -112.000000) translate(19.500000, 124.000000) rotate(-180.000000) translate(-19.500000, -124.000000) translate(13.000000, 112.000000)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftMobile);
export default __webpack_public_path__ + "static/media/arrowLeftMobile.cff6e8b2.svg";
export { ForwardRef as ReactComponent };